<script setup lang="ts">
import { onMounted } from "vue";
import { ModalsContainer } from "vue-final-modal";
import "vue-final-modal/style.css";
import { usePromosSettingsStore } from "./stores/promosSettingsStore";

const promosSettingsStore = usePromosSettingsStore();

onMounted(() => {
  const promosSettings = document
    .getElementById("promotions-spa")
    ?.getAttribute("data-promo");
  promosSettingsStore.setPromosSettings(
    promosSettings ? JSON.parse(promosSettings) : {}
  );
});
</script>

<template>
  <div class="vacv-modalwrap">
    <modals-container />
    <div class="vacv-spa vacv-promotions-spa">
      <router-view />
    </div>
  </div>
</template>

<style lang="scss">
@use "vacv-components/style.css";
@use "assets/scss/promo-spa-theme.scss" as *;
\ #app > .vacv-spa > #nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
